
$(document).ready(function () {
  $("#navigation a.navigation-link").removeAttr("target");
  $(".navigation-tabs-nav-item a").removeAttr("target");

  $(" a.navigation-link").click(function (e) {
    var target_val = $(this).attr("target");
    if (target_val == "_blank") {
      $(this).removeAttr("target");
      return false;
    }
  });

  $(".navigation-tabs-nav-item a").click(function (e) {
    var target_val = $(this).attr("target");
    if (target_val == "_blank") {
      $(this).removeAttr("target"); 
      return false;
    }
  });
});




/*****Home mobile Slider*****/




let splideInstances = [];

function initSplideSlider() {

  const sliders = document.querySelectorAll('.slider-has');
  const isMobile = window.innerWidth <= 990;

  

  document.querySelectorAll('.shopify-section').forEach(function(el) {

    if (el.id.includes('__bt_custom_blocks_')) {
      el.querySelector('.slider-has').classList.remove('pb-7');
      const nextDiv = el.nextElementSibling;
      if (
        nextDiv &&
        nextDiv.tagName.toLowerCase() === 'div' &&
        nextDiv.id.includes('__bt_custom_blocks_')
      ) {
        el.style.marginBottom = '0px';
      }else{
        el.style.marginBottom = '-15px';
      }
    }
  });

  sliders.forEach((container, index) => {

    const isMobile = window.innerWidth <= 1024;

    const slider = container.querySelector('.image-row-item');
    const grandparent = container.parentElement?.parentElement;    

    if (!slider) return;

    // Store Splide instance on the element itself
    if (isMobile && !slider.splideInstance) {      

      // Build Splide structure
      const track = document.createElement('div');
      track.className = 'splide__track';

      const list = document.createElement('ul');
      list.className = 'splide__list';

      const slides = Array.from(slider.children);
      slides.forEach(child => {
        const li = document.createElement('li');
        li.className = 'splide__slide';
        li.appendChild(child);
        list.appendChild(li);
      });

      track.appendChild(list);
      slider.classList.add('splide');
      slider.appendChild(track);

      var shopLocale = window.Shopify.locale;
      var isRTL = shopLocale === 'ar';

      const instance = new Splide(slider, {
        type: 'slide',
        perPage: 1,
        gap: '0em',
        arrows: false,
        pagination: true,
        direction: isRTL ? 'rtl' : 'ltr'
      });

      instance.mount();
      slider.splideInstance = instance;
      splideInstances[index] = instance;

    } else if (!isMobile && slider.splideInstance) {

      slider.splideInstance.destroy();
      slider.splideInstance = null;
      splideInstances[index] = null;

      // Restore original structure
      const track = slider.querySelector('.splide__track');
      const originalSlides = track?.querySelectorAll('.splide__slide > *');

      if (track && originalSlides) {
        originalSlides.forEach(slide => slider.appendChild(slide));
        track.remove();
      }

      slider.classList.remove('splide');
    }
  });
}

initSplideSlider(); 

// Initial run and re-check on resize
window.addEventListener('DOMContentLoaded', initSplideSlider);
window.addEventListener('resize', initSplideSlider);

/****************************/



// custom code for add to compare checked if findify filter is applied!

setInterval(() => {
  const section = document.querySelector('.findify-products-section');
  if (section) {
      
      const productCards = Array.from(section.querySelectorAll('.findify-product-card'));
      const storedData = localStorage.getItem('compare_products');
      
      if (storedData) {
          const storedProductIds = JSON.parse(storedData).map(item => item.id);
          productCards.forEach(card => {
              const cardId = card.getAttribute('id');
              if (storedProductIds.includes(cardId)) {
                  const checkbox = card.querySelector('.compare-checkbox');
                  if (checkbox && !checkbox.checked) {
                      checkbox.checked = true;
                  }
              }
          });
      }
  }
}, 1000); 



function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
              formatString = format || '${{amount}}';

      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
                dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
      }

      var value = '';

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;

        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;

        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;

        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;

        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;

        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      }

      if (formatString.indexOf('with_comma_separator') !== -1) {
        return formatString.replace(placeholderRegex, value);
      } else {
        return formatString.replace(placeholderRegex, value);
      }
    }

    // add to cart function

  async function addToCartDefault(variantId, button) {
    

    if (!variantId) return;

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    if(button) button.innerHTML = "Adding..";

    try {
      const response = await fetch("/cart/add.js", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        }),
        credentials: 'same-origin'
      });

      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        if(button) button.innerHTML = "Item Added!";

        setTimeout(() => {
          if(button) button.innerHTML = "Add to Cart";
        }, 2000);

      } else {
        const content = await response.json();
        const errorMsg = content['description'] || 'Failed to add to cart.';
        console.log('error', errorMsg);
        throw new Error(errorMsg);
      }
    } catch (error) {
      console.log('error', 'Error adding items to cart: ' + error.message);
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
}
function shrinkOverflowingText(selector, maxSize = 12, minSize = 9) {
    const elements = document.querySelectorAll(selector);

    elements.forEach(el => {
      el.style.fontSize = `${maxSize}px`;

      console.log("testing", el.scrollWidth, el.clientWidth);

      if (el.scrollWidth > el.clientWidth) {
        el.style.setProperty('font-size', `${minSize}px`, 'important');
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    shrinkOverflowingText(".auto-shrink-text", 12, 10);
  });
